import localization from "../../../../assets/localization";
import Analytics from "../../../../utils/Analytics";

/**
 * "Continue on WhatsApp", offered beside "speak with an operator" when the
 * hotel has both a WhatsApp number and the toggle on.
 *
 * Worth knowing when reading this: WhatsApp threads are keyed by the guest's
 * phone number, so this does NOT move the current conversation — it starts a
 * fresh one with the hotel's WhatsApp assistant. The prefilled text exists so
 * the guest does not have to re-explain themselves from scratch.
 */

/** wa.me wants digits only: no +, no spaces, no dashes. */
const toWaMeNumber = (phoneNumber?: string) =>
  (phoneNumber ?? "").replace(/\D/g, "");

export default function WhatsappHandoffButton({
  phoneNumber,
  language,
  show,
}: {
  phoneNumber?: string;
  language: string;
  show: boolean;
}) {
  const number = toWaMeNumber(phoneNumber);

  if (!show || !number) return null;

  const t = localization.get(language);
  const href = `https://wa.me/${number}?text=${encodeURIComponent(
    t.whatsapp_handoff_prefill
  )}`;

  return (
    <div className="shortcut-buttons">
      <a
        className="shortcut-button whatsapp-handoff-button"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() =>
          // Same event as every other outbound link so it lands in the existing
          // conversion funnel rather than in a metric of its own.
          Analytics.track("link_click", {
            url: href,
            cta: "whatsapp_handoff",
            source: "message_cta",
          })
        }
      >
        <svg
          className="whatsapp-handoff-glyph"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path
            fill="currentColor"
            d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.87 9.87 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 18.15h-.01a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.83 2.41a8.18 8.18 0 0 1 2.41 5.83c0 4.54-3.7 8.23-8.24 8.23Zm4.52-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.24-.64.8-.78.97-.14.16-.29.18-.54.06-.25-.13-1.05-.39-1.99-1.23-.74-.66-1.24-1.47-1.38-1.72-.15-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.15.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43h-.48c-.16 0-.43.06-.65.31-.23.25-.86.84-.86 2.05s.88 2.38 1 2.54c.12.17 1.73 2.64 4.2 3.7.59.26 1.04.41 1.4.52.59.19 1.12.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.15-1.18-.06-.11-.22-.17-.47-.29Z"
          />
        </svg>
        <span>{t.continue_on_whatsapp}</span>
      </a>
    </div>
  );
}
